/**
 * AP Software
 * AP Software REST API.
 *
 * OpenAPI spec version: 3.5.0
 * Contact: support@ap-software.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TicketQuery { 
    assigneeIds?: Array<number>;
    authorIds?: Array<number>;
    bodyText?: string;
    categoryIds?: Array<number>;
    customerIds?: Array<number>;
    hasAlarm?: boolean;
    hasDeadline?: boolean;
    maxAlarm?: Date;
    maxCreation?: Date;
    maxDate?: Date;
    maxDeadline?: Date;
    maxPriority?: number;
    minAlarm?: Date;
    minCreation?: Date;
    minDate?: Date;
    minDeadline?: Date;
    minPriority?: number;
    orderBy?: TicketQuery.OrderByEnum;
    orderDescending?: boolean;
    resolved?: boolean;
    searchTerm?: string;
    statusIds?: Array<number>;
    subjectText?: string;
    teamIds?: Array<number>;
    waiting?: boolean;
    watcherIds?: Array<number>;
}
export namespace TicketQuery {
    export type OrderByEnum = 'TEAM' | 'ASSIGNEE' | 'AUTHOR' | 'CREATED' | 'UPDATED' | 'ALARM' | 'DEADLINE' | 'SUBJECT' | 'BODY' | 'STATUS' | 'PRIORITY' | 'CATEGORY' | 'CUSTOMERS';
    export const OrderByEnum = {
        TEAM: 'TEAM' as OrderByEnum,
        ASSIGNEE: 'ASSIGNEE' as OrderByEnum,
        AUTHOR: 'AUTHOR' as OrderByEnum,
        CREATED: 'CREATED' as OrderByEnum,
        UPDATED: 'UPDATED' as OrderByEnum,
        ALARM: 'ALARM' as OrderByEnum,
        DEADLINE: 'DEADLINE' as OrderByEnum,
        SUBJECT: 'SUBJECT' as OrderByEnum,
        BODY: 'BODY' as OrderByEnum,
        STATUS: 'STATUS' as OrderByEnum,
        PRIORITY: 'PRIORITY' as OrderByEnum,
        CATEGORY: 'CATEGORY' as OrderByEnum,
        CUSTOMERS: 'CUSTOMERS' as OrderByEnum
    };
}